// extracted by mini-css-extract-plugin
module.exports = {"EduActivityPreview":"EduActivityPreview_EduActivityPreview__1Vtih","Category":"EduActivityPreview_Category__1J6Xw","ActivityAreas":"EduActivityPreview_ActivityAreas__2TbsT"};